import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '../../assets/liftbase-logo.png'


const _hoisted_1 = { id: "nav" }
const _hoisted_2 = { class: "branding" }
const _hoisted_3 = {
  key: 0,
  class: "nav-right"
}
const _hoisted_4 = { class: "actions" }
const _hoisted_5 = { class: "btn-new-txt" }
const _hoisted_6 = { class: "router-link-button color-grey" }
const _hoisted_7 = { class: "router-link-button color-grey" }
const _hoisted_8 = { class: "router-link-button color-grey" }
const _hoisted_9 = { class: "router-link-button color-grey" }
const _hoisted_10 = { class: "router-link-button color-grey" }
const _hoisted_11 = { class: "router-link-button color-grey" }
const _hoisted_12 = { class: "btn-new-txt" }
const _hoisted_13 = { class: "btn-new-txt" }
const _hoisted_14 = { class: "btn-new-txt" }
const _hoisted_15 = { class: "burger-menu" }
const _hoisted_16 = { class: "role" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 1,
  class: "txt-small"
}
const _hoisted_19 = {
  key: 3,
  class: "tenant txt-small"
}
const _hoisted_20 = {
  key: 0,
  class: "login-menu"
}
const _hoisted_21 = { class: "tenant-switcher-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_collapse_transition = _resolveComponent("el-collapse-transition")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: "",
        class: "router-link-button step-logo",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.refreshCurrentView && _ctx.refreshCurrentView(...args)), ["prevent"]))
      }, [...(_cache[31] || (_cache[31] = [
        _createElementVNode("img", {
          src: _imports_0,
          class: "logo",
          alt: "company logo"
        }, null, -1)
      ]))])
    ]),
    (_ctx.currentUser && !_ctx.isOnboarding)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.shouldShowDocumentCreateDropdown)
              ? (_openBlock(), _createBlock(_component_el_dropdown, {
                  key: 0,
                  "hide-on-click": ""
                }, {
                  dropdown: _withCtx(() => [
                    _createVNode(_component_el_dropdown_menu, null, {
                      default: _withCtx(() => [
                        (_ctx.isProcurementModuleActive())
                          ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                              key: 0,
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'ai-procurement'})))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_6, [
                                  _createVNode(_component_el_tag, {
                                    type: "primary",
                                    class: "doc-abbr"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('overview_page.procurement_abbr')), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode("    " + _toDisplayString(_ctx.$t('procurement.order_description')), 1)
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.isContractModuleActive())
                          ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                              key: 1,
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'form-procurement', query: {'select-contract': true}})))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_7, [
                                  _createVNode(_component_el_tag, {
                                    type: "primary",
                                    class: "doc-abbr"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('overview_page.procurement_abbr')), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode("    " + _toDisplayString(_ctx.$t('procurement.page.new_from_contract')), 1)
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.isInvoiceModuleActive())
                          ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                              key: 2,
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push({ name: 'invoice-upload'})))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_8, [
                                  _createVNode(_component_el_tag, {
                                    type: "success",
                                    class: "doc-abbr"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('overview_page.invoice_abbr')), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode("    " + _toDisplayString(_ctx.$t('invoice.description')), 1)
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.isOutgoingInvoiceModuleActive())
                          ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                              key: 3,
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push({ name: 'outgoing-invoice-upload'})))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_9, [
                                  _createVNode(_component_el_tag, { class: "doc-abbr doc-type-tag--outgoing-invoice" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('overview_page.outgoing_invoice_abbr')), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode("    " + _toDisplayString(_ctx.$t('outgoing_invoice.description')), 1)
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.isBankStatementModuleActive())
                          ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                              key: 4,
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.gotoView('bank-statement-upload', 'invoice-bank-statements', 'statement_upload_nav_open')))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_10, [
                                  _createVNode(_component_el_tag, {
                                    type: "info",
                                    class: "doc-abbr"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('bank_statement.abbr')), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode("    " + _toDisplayString(_ctx.$t('bank_statement.description')), 1)
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.isContractModuleActive() && _ctx.canInsertContract)
                          ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                              key: 5,
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push({ name: 'contract-add'})))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_11, [
                                  _createVNode(_component_el_tag, {
                                    type: "warning",
                                    class: "doc-abbr"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('overview_page.contract_abbr')), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode("    " + _toDisplayString(_ctx.$t('contract.description')), 1)
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, { type: "primary" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_fa, { icon: "plus" }),
                        _cache[32] || (_cache[32] = _createTextVNode("    ", -1)),
                        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('add')), 1),
                        _cache[33] || (_cache[33] = _createTextVNode("   ", -1)),
                        _createVNode(_component_fa, { icon: "angle-down" })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_ctx.isOnlyProcurementModuleActive())
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: { name: 'ai-procurement'},
                    class: "router-link-button btn-new"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _cache[7] || (_cache[7] = () => {})
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_fa, { icon: "plus" }),
                          _cache[34] || (_cache[34] = _createTextVNode("    ", -1)),
                          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('procurement.order_description')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : (_ctx.isOnlyInvoiceModuleActive() && !_ctx.isBankStatementModuleActive())
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 2,
                      to: { name: 'form-invoice'},
                      class: "router-link-button btn-new"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _cache[8] || (_cache[8] = () => {})
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_fa, { icon: "plus" }),
                            _cache[35] || (_cache[35] = _createTextVNode("    ", -1)),
                            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('invoice.description')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : (_ctx.isOnlyOutgoingInvoiceModuleActive() && !_ctx.isBankStatementModuleActive())
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 3,
                        to: { name: 'outgoing-invoice-upload'},
                        class: "router-link-button btn-new"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: _cache[9] || (_cache[9] = () => {})
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_fa, { icon: "plus" }),
                              _cache[36] || (_cache[36] = _createTextVNode("    ", -1)),
                              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('outgoing_invoice.description')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_el_button, { onClick: _ctx.toggle }, {
              default: _withCtx(() => [
                _createVNode(_component_fa, { icon: "bars" })
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("div", {
            class: "menu step-user-menu",
            onMouseleave: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.startCloseDelay && _ctx.startCloseDelay(...args))),
            onFocusout: _cache[29] || (_cache[29] = ($event: any) => (_ctx.loginMenuVisible = false)),
            onMouseenter: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.cancelCloseDelay && _ctx.cancelCloseDelay(...args)))
          }, [
            (_ctx.currentUser)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "login-info",
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
                }, [
                  _createVNode(_component_fa, {
                    icon: "ellipsis-vertical",
                    class: "menu-icon"
                  }),
                  _createElementVNode("div", _hoisted_16, [
                    (_ctx.user)
                      ? (_openBlock(), _createElementBlock("b", _hoisted_17, _toDisplayString(_ctx.user.name), 1))
                      : _createCommentVNode("", true),
                    (_ctx.user)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.user.email), 1))
                      : _createCommentVNode("", true),
                    (_ctx.shouldShowTenantSwitcher)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          class: "tenant-switcher tenant-switcher-inline",
                          onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"])),
                          onMousedown: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"]))
                        }, [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.selectedTenantId,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedTenantId) = $event)),
                            clearable: false,
                            loading: _ctx.tenantOptionsLoading || _ctx.tenantSwitchInProgress,
                            disabled: _ctx.tenantOptionsLoading || _ctx.tenantSwitchInProgress,
                            filterable: "",
                            size: "small",
                            onChange: _ctx.onTenantChange
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tenantOptions, (tenantOption) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: tenantOption.id,
                                  label: tenantOption.name,
                                  value: tenantOption.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "loading", "disabled", "onChange"])
                        ], 32))
                      : (_ctx.user?.tenant)
                        ? (_openBlock(), _createElementBlock("b", _hoisted_19, _toDisplayString(_ctx.user.tenant?.name), 1))
                        : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_collapse_transition, null, {
              default: _withCtx(() => [
                (_ctx.loginMenuVisible)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      (_ctx.shouldShowTenantSwitcher)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "tenant-switcher-menu",
                            onClick: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"])),
                            onMousedown: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"]))
                          }, [
                            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('login.email.tenant')), 1),
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.selectedTenantId,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.selectedTenantId) = $event)),
                              clearable: false,
                              loading: _ctx.tenantOptionsLoading || _ctx.tenantSwitchInProgress,
                              disabled: _ctx.tenantOptionsLoading || _ctx.tenantSwitchInProgress,
                              filterable: "",
                              onChange: _ctx.onTenantChange
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tenantOptions, (tenantOption) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: tenantOption.id,
                                    label: tenantOption.name,
                                    value: tenantOption.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "loading", "disabled", "onChange"])
                          ], 32))
                        : _createCommentVNode("", true),
                      (_ctx.canAccessDashboardHub)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "option",
                            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.gotoView('dashboards', 'dashboards', 'sidebar_open_dashboards')))
                          }, [
                            _createVNode(_component_fa, {
                              icon: "chart-pie",
                              class: "item-menu-icon"
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('dashboards')), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: "option",
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.gotoView('overview', 'document-inbox', 'sidebar_open_overview')))
                      }, [
                        _createVNode(_component_fa, {
                          icon: "inbox",
                          class: "item-menu-icon"
                        }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('overview')), 1)
                      ]),
                      (_ctx.isOperator && !_ctx.isLoggedAsOtherUser())
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: "option",
                            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.gotoView('exceptions-center')))
                          }, [
                            _createVNode(_component_fa, {
                              icon: "list-check",
                              class: "item-menu-icon"
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('exceptions_center.menu_title')), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isBankStatementModuleActive() && _ctx.hasAccessToBankStatementTransactions)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 3,
                            class: "option",
                            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.gotoView('bank-statement-transactions')))
                          }, [
                            _createVNode(_component_fa, {
                              icon: "list",
                              class: "item-menu-icon"
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('bank_statement.transactions_menu')), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isLiquidityPlanningModuleActive() && _ctx.hasAccessToLiquidityPlanning)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 4,
                            class: "option",
                            onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.gotoView('liquidity-planning')))
                          }, [
                            _createVNode(_component_fa, {
                              icon: "chart-line",
                              class: "item-menu-icon"
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('configuration.template.module-liquidity-planning.label')), 1)
                          ]))
                        : _createCommentVNode("", true),
                      ((!_ctx.isAdmin || _ctx.isLoggedAsOtherUser()) && _ctx.hasAnyMasterDataPermission)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 5,
                            class: "option",
                            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.gotoView('admin', 'advanced-master-data', 'sidebar_open_master_data')))
                          }, [
                            _createVNode(_component_fa, {
                              icon: "circle-nodes",
                              class: "item-menu-icon"
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('master_data')), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.isLoggedAsOtherUser())
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                            (_ctx.isAdmin)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "option step-profil-admin admin",
                                  onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.gotoView('list-client', 'advanced-master-data', 'sidebar_open_admin')))
                                }, [
                                  _createVNode(_component_fa, {
                                    icon: "gear",
                                    class: "item-menu-icon"
                                  }),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('administration')), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.isOperator)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: "option",
                                  onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.gotoView('operator')))
                                }, [
                                  _createVNode(_component_fa, {
                                    icon: "sliders",
                                    class: "item-menu-icon"
                                  }),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('operator')), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", {
                              class: "option step-profil-admin",
                              onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.gotoView('profile')))
                            }, [
                              _createVNode(_component_fa, {
                                icon: "user",
                                class: "item-menu-icon"
                              }),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('profile')), 1)
                            ]),
                            _createElementVNode("div", {
                              class: "option step-menu-help",
                              onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.gotoView('help')))
                            }, [
                              _createVNode(_component_fa, {
                                icon: "circle-question",
                                class: "item-menu-icon"
                              }),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('help')), 1)
                            ]),
                            _createElementVNode("div", {
                              class: "option",
                              onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.gotoView('logout')))
                            }, [
                              _createVNode(_component_fa, {
                                icon: "arrow-left-long",
                                class: "item-menu-icon"
                              }),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('logout')), 1)
                            ])
                          ], 64))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ], 32)
        ]))
      : _createCommentVNode("", true)
  ]))
}